import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

export default function useDateActions() {
  const { t } = useI18n({ useScope: 'global' });

  const presetDateRanges = computed(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const todayEnd = new Date();
    todayEnd.setHours(23, 59, 59, 999);

    const last30 = new Date(today);
    last30.setDate(today.getDate() - 30);

    const thisMonthBegin = new Date(today);
    thisMonthBegin.setDate(1);
    const thisMonthEnd = new Date(todayEnd);
    thisMonthEnd.setMonth(todayEnd.getMonth() + 1, 0);

    const lastMonthBegin = new Date(today);
    lastMonthBegin.setMonth(thisMonthEnd.getMonth() - 1, 1);
    const lastMonthEnd = new Date(todayEnd);
    lastMonthEnd.setMonth(todayEnd.getMonth(), 0);

    const thisYearBegin = new Date(today);
    thisYearBegin.setFullYear(today.getFullYear(), 0, 1);
    const thisYearEnd = new Date(todayEnd);
    thisYearEnd.setFullYear(todayEnd.getFullYear() + 1, 0, 0);

    return [
      { label: t('JTADM_CALENDAR_TODAY'), value: [today, todayEnd] },
      { label: t('JTADM_CALENDAR_LAST_30'), value: [last30, todayEnd] },
      { label: t('JTADM_CALENDAR_THIS_MONTH'), value: [thisMonthBegin, thisMonthEnd] },
      { label: t('JTADM_CALENDAR_LAST_MONTH'), value: [lastMonthBegin, lastMonthEnd] },
      { label: t('JTADM_CALENDAR_THIS_YEAR'), value: [thisYearBegin, thisYearEnd] },
    ];
  });

  return {
    presetDateRanges,
  };
}
